var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.563.555c.2-.252.48-.43.794-.503.256-.07.527-.07.782 0 .315.073.596.25.798.503l4.131 3.966a1.362 1.362 0 010 1.987l-.046.043a1.51 1.51 0 01-2.073 0L7.247 4.919v10.894c0 .794-.64 1.438-1.433 1.438h-.13a1.436 1.436 0 01-1.433-1.438V4.916L2.548 6.552a1.51 1.51 0 01-2.073 0L.43 6.508a1.364 1.364 0 010-1.987L4.563.555zm13.872 21.891c-.2.252-.48.43-.793.503a1.533 1.533 0 01-.782 0 1.432 1.432 0 01-.798-.503L11.93 18.48a1.365 1.365 0 010-1.987l.046-.043a1.51 1.51 0 012.073 0l1.704 1.632V7.188c0-.794.641-1.438 1.433-1.438h.13c.79 0 1.433.644 1.433 1.438v10.897l1.703-1.635a1.51 1.51 0 012.073 0l.046.045a1.364 1.364 0 010 1.986l-4.136 3.965z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIconBlue);
export default __webpack_public_path__ + "static/media/sort-icon-blue.05974091fca2c8a34535d8bf73055da1.svg";
export { ForwardRef as ReactComponent };